module.exports = __webpack_public_path__ + "static/media/mail-icon.2a5e487e.svg";